import {RaEvent, RaEventType} from "./RaEvent";

export enum PleaseWaitTarget {
    LIBRARY = <any>"Library",
    READING = <any>"Reading",
    POINTS = <any>"Points",
    ANY = <any>"Any"
};

export class BookIntroLaunchEvent extends RaEvent {
    static TYPE: RaEventType = "book_intro_launch_event";

    constructor() {
        super(BookIntroLaunchEvent.TYPE);
    }
}

export class BookIntroEndEvent extends RaEvent {
    static TYPE: RaEventType = "book_intro_end_event";

    constructor() {
        super(BookIntroEndEvent.TYPE);
    }
}

export class SelectionLoadedEvent extends RaEvent {
    static TYPE: RaEventType = "selection_loaded_event";

    constructor(private titleName: string) {
        super(SelectionLoadedEvent.TYPE);
    }

    public get name(): string {
        return this.titleName;
    }
}

export class ResetSelectionLoadedEvent extends RaEvent {
    static TYPE: RaEventType = "reset_selection_loaded_event";

    constructor() {
        super(ResetSelectionLoadedEvent.TYPE);
    }
}

export class PleaseWaitEvent extends RaEvent {

    private show: boolean;
    private audio: boolean;
    private soft: boolean;
    private destination: PleaseWaitTarget;

    static TYPE: RaEventType = "please_wait_event";

    constructor(data: {show: boolean, audio: boolean, destination: PleaseWaitTarget, soft?: boolean}) {
        super(PleaseWaitEvent.TYPE);

        this.show = data.show;
        this.audio = data.audio;
        this.soft = data.soft;
        this.destination = data.destination;
    }

    public get visible(): boolean {
        return this.show;
    }

    public get softVisibility(): boolean {
        return this.soft;
    }

    public get playAudio(): boolean {
        return this.audio;
    }

    public get target(): PleaseWaitTarget {
        return this.destination;
    }

}

export class PleaseWaitHiddenEvent extends RaEvent {

    static TYPE: RaEventType = "please_wait_hidden_event";

    constructor(private destination: PleaseWaitTarget) {
        super(PleaseWaitHiddenEvent.TYPE);
    }

    public get target(): PleaseWaitTarget {
        return this.destination;
    }
}
